<template>
  <div v-show="data.report.results.length > 0" class="table-responsive">
    <table class="table table-condensed standard-report" v-show="data.report.results">
      <thead>
        <tr class="table-header header text-left">
          <th>&nbsp;</th>
          <th colspan="5" class="text-center border-left-1">{{ dailyDate | moment('YYYY-M-D') }}</th>
          <th colspan="5" class="text-center border-left-1">Week To Date</th>
          <th colspan="5" class="text-center border-left-1">Period To Date</th>
        </tr>
        <tr class="table-header header text-left">
          <th class="text-left">
            <span class>Category</span>
          </th>
          <th class="text-center border-left-1">
            <span class>Hours</span>
          </th>
          <th class="text-right">
            <span class>Payroll</span>
          </th>
          <th class="text-center">
            <span class>% of Sales</span>
          </th>
          <th class="text-center">
            <span class>&nbsp;</span>
          </th>
          <th class="text-right">
            <span class>SPMH</span>
          </th>
          <!--WTD -->
          <th class="text-center border-left-1">
            <span class>Hours</span>
          </th>
          <th class="text-right">
            <span class>Payroll</span>
          </th>
          <th class="text-center">
            <span class>% of Sales</span>
          </th>
          <th class="text-center">
            <span class>&nbsp;</span>
          </th>
          <th class="text-right">
            <span class>SPMH</span>
          </th>
          <!--PTD-->
          <th class="text-center border-left-1">
            <span class>Hours</span>
          </th>
          <th class="text-right">
            <span class>Payroll</span>
          </th>
          <th class="text-center">
            <span class>% of Sales</span>
          </th>
          <th class="text-center">
            <span class>&nbsp;</span>
          </th>
          <th class="text-right">
            <span class>SPMH</span>
          </th>
        </tr>
      </thead>
      <tbody
        v-show="data.report.results.length > 0"
        v-for="(c, ck) in data.report.results"
        :key="ck"
      >
        <tr class="border-right" style="background-color: transparent;">
          <td colspan="4">
            <strong>{{ c.name }}</strong>
          </td>
          <td>
            <span v-show="c.department != ''">% of {{ c.department }} Sales</span>
          </td>
          <td colspan="4">&nbsp;</td>
          <td>
            <span v-show="c.department != ''">% of {{ c.department }} Sales</span>
          </td>
          <td colspan="4">&nbsp;</td>
          <td>
            <span v-show="c.department != ''">% of {{ c.department }} Sales</span>
          </td>
          <td>&nbsp;</td>
        </tr>
        <tr
          class="border-right"
          v-for="(v, vk) in c.results"
          :key="vk"
          v-show="c.results.length > 0"
          style="background-color: #f9f9f9;"
        >
          <td class="text-left">{{ v.jobname }}</td>
          <td class="text-center">{{ v.totalhours }}</td>
          <td class="text-right">{{ v.laborcost | currency }}</td>
          <td class="text-center">{{ v.laborcostpct }}%</td>
          <td class="text-center">
            <span v-show="v.departmentsales > 0">{{ v.departmentsalespct }}%</span>
          </td>
          <td class="text-center"></td>
          <!--wtd-->
          <td class="text-center">{{ v.wtdtotalhours }}</td>
          <td class="text-right">{{ v.wtdlaborcost | currency }}</td>
          <td class="text-center">{{ v.wtdlaborcostpct }}%</td>
          <td class="text-center">
            <span v-show="v.wtddepartmentsales > 0">{{ v.wtddepartmentsalespct }}%</span>
          </td>
          <td class="text-center"></td>
          <!--ptd-->
          <td class="text-center">{{ v.ptdtotalhours }}</td>
          <td class="text-right">{{ v.ptdlaborcost | currency }}</td>
          <td class="text-center">{{ v.ptdlaborcostpct }}%</td>
          <td class="text-center">
            <span v-show="v.ptddepartmentsales > 0">{{ v.ptddepartmentsalespct }}%</span>
          </td>
          <td class="text-center"></td>
        </tr>
        <tr class="border-right" style="background-color: #f9f9f9;">
          <td class="text-right">
            <strong>{{ c.name }} Sub-Totals:</strong>
          </td>
          <td class="text-center">{{ c.totalhours }}</td>
          <td class="text-right">{{ c.laborcost | currency }}</td>
          <td class="text-center">{{ c.laborcostpct }}%</td>
          <td class="text-center">
            <span v-show="c.departmentsales > 0">{{ c.departmentsalespct }}%</span>
          </td>
          <td class="text-right">{{ c.spmh | currency }}</td>
          <!--wtd-->
          <td class="text-center">{{ c.wtdtotalhours }}</td>
          <td class="text-right">{{ c.wtdlaborcost | currency }}</td>
          <td class="text-center">{{ c.wtdlaborcostpct }}%</td>
          <td class="text-center">
            <span v-show="c.wtddepartmentsales > 0">{{ c.wtddepartmentsalespct }}%</span>
          </td>
          <td class="text-right">{{ c.wtdspmh | currency }}</td>
          <!--ptd-->
          <td class="text-center">{{ c.ptdtotalhours }}</td>
          <td class="text-right">{{ c.ptdlaborcost | currency }}</td>
          <td class="text-center">{{ c.ptdlaborcostpct }}%</td>
          <td class="text-center">
            <span v-show="c.ptddepartmentsales > 0">{{ c.ptddepartmentsalespct }}%</span>
          </td>
          <td class="text-right">{{ c.ptdspmh | currency }}</td>
        </tr>

        <tr class="border-right">
          <td colspan="6">&nbsp;</td>
        </tr>
      </tbody>
      <tr class="border-right" style="background-color: #f9f9f9;">
        <td class="text-right">
          <strong>Hourly Totals:</strong>
        </td>
        <td class="text-center">
          <strong>{{ data.report.results.totalhours }}</strong>
        </td>
        <td class="text-right">
          <strong>{{ data.report.results.laborcost | currency }}</strong>
        </td>
        <td class="text-center">
          <strong>{{ data.report.results.laborcostpct }}%</strong>
        </td>
        <td></td>
        <td class="text-right">
          <strong>{{ data.report.results.spmh | currency }}</strong>
        </td>
        <!--wtd-->
        <td class="text-center">
          <strong>{{ data.report.results.wtdtotalhours }}</strong>
        </td>
        <td class="text-right">
          <strong>{{ data.report.results.wtdlaborcost | currency }}</strong>
        </td>
        <td class="text-center">
          <strong>{{ data.report.results.wtdlaborcostpct }}%</strong>
        </td>
        <td></td>
        <td class="text-right">
          <strong>{{ data.report.results.wtdspmh | currency }}</strong>
        </td>
        <!--ptd-->
        <td class="text-center">
          <strong>{{ data.report.results.ptdtotalhours }}</strong>
        </td>
        <td class="text-right">
          <strong>{{ data.report.results.ptdlaborcost | currency }}</strong>
        </td>
        <td class="text-center">
          <strong>{{ data.report.results.ptdlaborcostpct }}%</strong>
        </td>
        <td></td>
        <td class="text-right">
          <strong>{{ data.report.results.ptdspmh | currency }}</strong>
        </td>
      </tr>

      <tr
        class="border-right"
        v-show="data.report.mgmt.flat_management_hours > 0 || data.report.mgmt.fee > 0"
      >
        <td colspan="16">&nbsp;</td>
      </tr>
      <tr
        class="border-right"
        style="background-color: #f9f9f9;"
        v-show="data.report.mgmt.hours > 0 || data.report.mgmt.fee > 0"
      >
        <td class="text-right">
          <strong>Management Salary:</strong>
        </td>
        <td class="text-center">
          <span
            v-show="data.report.mgmt.hours > 0"
          >{{ data.report.mgmt.hours }}</span>
          <span v-show="!data.report.mgmt.hours > 0">-</span>
        </td>
        <td class="text-right">{{ data.report.mgmt.fee | currency }}</td>
        <td
          class="text-center"
        >{{ data.report.mgmt.feepct }}%</td>
        <td></td>
        <td></td>
        <!--wtd-->
        <td class="text-center">
          <span
            v-show="data.report.mgmt.wtdhours > 0"
          >{{ data.report.mgmt.wtdhours}}</span>
          <span v-show="!data.report.mgmt.wtdhours > 0">-</span>
        </td>
        <td class="text-right">{{ data.report.mgmt.wtdfee | currency }}</td>
        <td
          class="text-center"
        >{{ (data.report.mgmt.wtdfee / data.wtdsales) * 100 }}%</td>
        <td></td>
        <td></td>
        <!--ptd-->
        <td class="text-center">
          <span
            v-show="data.report.mgmt.ptdhours > 0"
          >{{ data.report.mgmt.ptdhours}}</span>
          <span v-show="!data.report.mgmt.ptdhours > 0">-</span>
        </td>
        <td class="text-right">{{ data.report.mgmt.ptdfee | currency }}</td>
        <td
          class="text-center"
        >{{ (data.report.mgmt.ptdfee / data.ptdsales) * 100 }}%</td>
        <td></td>
        <td></td>
      </tr>
      <tbody v-show="!data.report.results.length > 0">
        <tr class="border-right" v-show="!data.report.results.length > 0">
          <td class="text-center" colspan="16">NO DATA AVAILABLE</td>
        </tr>
      </tbody>
      <tfoot v-show="data.report.results.length > 0">
        <tr class="border-right">
          <td colspan="16">&nbsp;</td>
        </tr>
        <tr class="border-right">
          <td class="text-right">
            <strong>Totals:</strong>
          </td>
          <td class="text-center" style="background-color: #f9f9f9;">
            <strong>{{ data.report.mgmt.totalhours }}</strong>
          </td>
          <td class="text-right" style="background-color: #f9f9f9;">
            <strong>{{ data.report.mgmt.laborcost | currency }}</strong>
          </td>
          <td class="text-center" style="background-color: #f9f9f9;">
            <strong>{{ data.report.mgmt.laborcostpct }}%</strong>
          </td>
          <td style="background-color: #f9f9f9;"></td>
          <td class="text-right" style="background-color: #f9f9f9;">
            <strong>{{ data.report.mgmt.spmh | currency }}</strong>
          </td>
          <!--wtd-->
          <td class="text-center" style="background-color: #f9f9f9;">
            <strong>{{ data.report.mgmt.wtdtotalhours }}</strong>
          </td>
          <td class="text-right" style="background-color: #f9f9f9;">
            <strong>{{ data.report.mgmt.wtdlaborcost | currency }}</strong>
          </td>
          <td class="text-center" style="background-color: #f9f9f9;">
            <strong>{{ data.report.mgmt.wtdlaborcostpct }}%</strong>
          </td>
          <td style="background-color: #f9f9f9;"></td>
          <td class="text-right" style="background-color: #f9f9f9;">
            <strong>{{ data.report.mgmt.wtdspmh | currency }}</strong>
          </td>
          <!--ptd-->
          <td class="text-center" style="background-color: #f9f9f9;">
            <strong>{{ data.report.mgmt.ptdtotalhours }}</strong>
          </td>
          <td class="text-right" style="background-color: #f9f9f9;">
            <strong>{{ data.report.mgmt.ptdlaborcost | currency }}</strong>
          </td>
          <td class="text-center" style="background-color: #f9f9f9;">
            <strong>{{ data.report.mgmt.ptdlaborcostpct }}%</strong>
          </td>
          <td style="background-color: #f9f9f9;"></td>
          <td class="text-right" style="background-color: #f9f9f9;">
            <strong>{{ data.report.mgmt.ptdspmh | currency }}</strong>
          </td>
        </tr>
        <tr class="border-right">
          <td class="text-right">
            <strong>Budget:</strong>
          </td>
          <td class="text-center" style="background-color: #f9f9f9;"></td>
          <td class="text-right" style="background-color: #f9f9f9;">
            <strong>{{ data.report.budget.amount | currency }}</strong>
          </td>
          <td class="text-center" style="background-color: #f9f9f9;">
            <strong>{{ data.report.budget.pct }}%</strong>
          </td>
          <td style="background-color: #f9f9f9;"></td>
          <td class="text-right" style="background-color: #f9f9f9;">
            <strong>{{ data.report.budget.spmhgoal | currency }}</strong>
          </td>
          <!--wtd-->
          <td class="text-center" style="background-color: #f9f9f9;"></td>
          <td class="text-right" style="background-color: #f9f9f9;">
            <strong>{{ data.report.budget.wtdamount | currency }}</strong>
          </td>
          <td class="text-center" style="background-color: #f9f9f9;">
            <strong>{{ data.report.budget.wtdpct }}%</strong>
          </td>
          <td style="background-color: #f9f9f9;"></td>
          <td class="text-right" style="background-color: #f9f9f9;">
            <strong>{{ data.report.budget.wtdspmhgoal | currency }}</strong>
          </td>
          <!--ptd-->
          <td class="text-center" style="background-color: #f9f9f9;"></td>
          <td class="text-right" style="background-color: #f9f9f9;">
            <strong>{{ data.report.budget.ptdamount | currency }}</strong>
          </td>
          <td class="text-center" style="background-color: #f9f9f9;">
            <strong>{{ data.report.budget.ptdpct }}%</strong>
          </td>
          <td style="background-color: #f9f9f9;"></td>
          <td class="text-right" style="background-color: #f9f9f9;">
            <strong>{{ data.report.budget.ptdspmhgoal | currency }}</strong>
          </td>
        </tr>
        <tr class="border-right">
          <td class="text-right">
            <strong>Variance:</strong>
          </td>
          <td class="text-center" style="background-color: #f9f9f9;"></td>
          <td
            class="text-right"
            style="background-color: #f9f9f9;"
            :class="{ 'text-danger': data.report.variance.laborcost > 0, 'text-success': data.report.variance.laborcost < 0 }"
          >
            <strong>
              <span v-show="data.report.variance.laborcost > 0">+</span>
              {{ data.report.variance.laborcost | currency }}
            </strong>
          </td>
          <td
            class="text-center"
            style="background-color: #f9f9f9;"
            :class="{ 'text-danger': data.report.variance.laborcost > 0, 'text-success': data.report.variance.laborcost < 0 }"
          >
            <strong>
              <span v-show="data.report.variance.laborcostpct > 0">+</span>
              {{ data.report.variance.laborcostpct }}
            </strong>
          </td>
          <td style="background-color: #f9f9f9;"></td>
          <td
            class="text-right"
            style="background-color: #f9f9f9;"
            :class="{ 'text-success': data.report.variance.spmhgoal > 0, 'text-danger': data.report.variance.spmhgoal < 0 }"
          >
            <strong>
              <span v-show="data.report.variance.spmhgoal > 0">+</span>
              <span v-show="data.report.variance.spmhgoal < 0">-</span>
              {{ data.report.variance.spmhgoal | currency }}
            </strong>
          </td>
          <!--wtd-->
          <td class="text-center" style="background-color: #f9f9f9;"></td>
          <td
            class="text-right"
            style="background-color: #f9f9f9;"
            :class="{ 'text-danger': data.report.variance.wtdlaborcost > 0, 'text-success': data.report.variance.wtdlaborcost < 0 }"
          >
            <strong>
              <span v-show="data.report.variance.wtdlaborcost > 0">+</span>
              {{ data.report.variance.wtdlaborcost | currency }}
            </strong>
          </td>
          <td
            class="text-center"
            style="background-color: #f9f9f9;"
            :class="{ 'text-danger': data.report.variance.wtdlaborcost > 0, 'text-success': data.report.variance.wtdlaborcost < 0 }"
          >
            <strong>
              <span v-show="data.report.variance.wtdlaborcostpct > 0">+</span>
              {{ data.report.variance.wtdlaborcostpct }}
            </strong>
          </td>
          <td style="background-color: #f9f9f9;"></td>
          <td
            class="text-right"
            style="background-color: #f9f9f9;"
            :class="{ 'text-success': data.report.variance.wtdspmhgoal > 0, 'text-danger': data.report.variance.wtdspmhgoal < 0 }"
          >
            <strong>
              <span v-show="data.report.variance.wtdspmhgoal > 0">+</span>
              <span v-show="data.report.variance.wtdspmhgoal < 0">-</span>
              {{ data.report.variance.wtdspmhgoal | currency }}
            </strong>
          </td>
          <!--ptd-->
          <td class="text-center" style="background-color: #f9f9f9;"></td>
          <td
            class="text-right"
            style="background-color: #f9f9f9;"
            :class="{ 'text-danger': data.report.variance.ptdlaborcost > 0, 'text-success': data.report.variance.ptdlaborcost < 0 }"
          >
            <strong>
              <span v-show="data.report.variance.ptdlaborcost > 0">+</span>
              {{ data.report.variance.ptdlaborcost | currency }}
            </strong>
          </td>
          <td
            class="text-center"
            style="background-color: #f9f9f9;"
            :class="{ 'text-danger': data.report.variance.ptdlaborcost > 0, 'text-success': data.report.variance.ptdlaborcost < 0 }"
          >
            <strong>
              <span v-show="data.report.variance.ptdlaborcostpct > 0">+</span>
              {{ data.report.variance.ptdlaborcostpct }}
            </strong>
          </td>
          <td style="background-color: #f9f9f9;"></td>
          <td
            class="text-right"
            style="background-color: #f9f9f9;"
            :class="{ 'text-success': data.report.variance.ptdspmhgoal > 0, 'text-danger': data.report.variance.ptdspmhgoal < 0 }"
          >
            <strong>
              <span v-show="data.report.variance.ptdspmhgoal > 0">+</span>
              <span v-show="data.report.variance.ptdspmhgoal < 0">-</span>
              {{ data.report.variance.ptdspmhgoal | currency }}
            </strong>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import UserService from '@/services/UserService'
import DailyJournalReportService from '@/services/DailyJournalReportService'
import DailyReportTab from './dailyReportTab'

export default {
  extends: DailyReportTab,
  components: {
  },
  data () {
    return {
      data: {
        loading: true,
        report: {
          results: [],
          mgmt: {},
          budget: {},
          variance: []
        }
      },
      loadTimeout: null
    }
  },
  computed: {
    grossView: function () {
      return UserService.getConfigOption('gross_sales_view').value === 'yes'
    },
    checkGuestStats: function () {
      return UserService.getConfigOption('avg_check_guest_stats').value === 'yes'
    }
  },
  methods: {
    loadData: function () {
      if (this.isActive > 0 && this.loadTimeout === null) {
        this.loadTimeout = setTimeout(() => {
          this.$updateloading(1)
          this.data.loading = true
          DailyJournalReportService.getLaborSummary(this.locationId, this.dailyDate)
            .then(res => {
              this.$updateloading(-1)
              this.data.loading = false
              this.data.report = res
              this.loadTimeout = null
            })
        }, 100)
      }
    }
  }
}
</script>
